// @flow
import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';

import InfantPage from './infant/InfantPage.jsx';
import ChildPage from './child/ChildPage.jsx';

import 'chartist-plugin-axistitle';

import '../../../chartist-plugin-pointlabels';
import '../../../chartist-plugin-tooltip';
import '../../../styles/chartist-plugin-tooltip.global.css';
import '../../../styles/chartist.global.css';
import '../../../styles/chartistOverrides.global.css';

type Props = {
  match: {
    url: string,
  },
  dob: string,
}

class GrowthChartsPageComponent extends Component<Props> {
  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.url}/child`} component={ChildPage} />
        <Route path={`${this.props.match.url}/infant`} component={InfantPage} />
        <Route render={() => (this.props.dob && moment().diff(moment(this.props.dob), 'months') > 36
          ? <Redirect to={`${this.props.match.url}/child`} />
          : <Redirect to={`${this.props.match.url}/infant`} />)
        } />
      </Switch>
    );
  }
}

const mapStateToProps = state => ({
  dob: state.patient.data.generalInfo.dob,
});

const GrowthChartsPage = connect(
  mapStateToProps,
)(GrowthChartsPageComponent);

export default GrowthChartsPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/growthChart/GrowthChartsPage.jsx